import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import $ from 'jquery';
import { Category } from '../../models/category';
import { AuthService } from '../../access/auth.service';
import { CategoryService } from '../../pages/members/category/services/category.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-category-tree',
  templateUrl: './category-tree.component.html',
  styleUrls: ['./category-tree.component.scss']
})
export class CategoryTreeComponent implements OnInit {

  @Input() list: Category[] | undefined
  @Input() category: Category = new Category
  @Output() addCategoryEvent: EventEmitter<any> = new EventEmitter();
  @Output() editCategoryEvent: EventEmitter<any> = new EventEmitter();
  @Output() isSubCategory: EventEmitter<any> = new EventEmitter();

  constructor(
    private _service: CategoryService,
    private _auth: AuthService,
    private router: Router
  ) { }

  ngOnInit() {
  }

  collapseRecursive(category: Category) {
    if (category.categories) {
      category.categories.forEach((sub) => this.collapseRecursive(sub));
       // @ts-ignore
      category.categories = null;
    }
  }
  
  getSubs(category: Category) {
    if (category.categories != null) {
      this.collapseRecursive(category);
    } else {
      this._service
        .getSubcategories(this._auth.getStore().storeId, category.categoryId)
        .subscribe((res: any) => {
          category.categories = res || [];
        });
    }
  }

  eliminar(category: Category) {
    this.isSubCategory.emit(true);
    $("#modalDelete").removeClass('d-none');
    $("#modalDelete").attr('categoryid',category.categoryId);
  }
  
  addCategory(category: Category) {
    this.addCategoryEvent.emit(category)
  }
  
  editCategory(category: Category) {
    this.category = category
    this.editCategoryEvent.emit(category)
  }

  goToProductsByCategory(category){
    this.router.navigate(['/members/category/ProductsByCategrory', category.categoryId]);
  }

}
